import { Platform, StyleSheet } from "react-native";
import { Colors } from "../../../globalStyles/ColorConfig";
export const styles = StyleSheet.create({
  FeedContainer: {
    backgroundColor: "white",
    flex: 1,
  },
  ProfileCards: {},
  ProfileCard: {},
  ProfileCardImg: {},
  Paginatiom: {},
  SubscriptionFeature: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    // paddingVertical: 16,
    borderBottomColor: "rgba(0,0,0,0.14)",
    borderBottomWidth: 0.5,
  },
  LogoContainerIcon: {
    transform: [{ scale: 1.1 }],
  },
  LogoContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 16,
    marginVertical: 20,
  },
  HomeDisplayCardInfo: {
    position: "absolute",
    width: "100%",
    // top: "40%",
    bottom: "0%",
    zIndex: 3,
    height: Platform.OS === "web" ? 100 : 150,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  HomeDisplayCardInfoInner: {
    width: "100%",
    position: "absolute",
    paddingHorizontal: 20,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    bottom: 20,
  },
  BadgeLabel: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
  },
  DatingProfileDetails: {
    paddingHorizontal: 16,
    marginTop: 16,
  },
  ProfileItem: {
    marginTop: 28,
  },
  PillItem: {
    borderColor: "rgba(0, 0, 0, 0.3)",
    borderWidth: 0.3,
    borderRadius: 50,
    display: "flex",
    gap: 4,
    flexDirection: "row",
    alignItems: "center",
    padding: 6,
  },
  HomeDisplayCardImg: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  Pills: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    gap: 8,
    marginTop: 8,
  },
  LikeIconCircle: {
    backgroundColor: "white",
    borderRadius: 50,
    padding: 16,
    zIndex: 1,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 0,
    },
    shadowOpacity: 0.4,
    shadowRadius: 10,
    elevation: 1,
  },
  WaitingListCard: {
    backgroundColor: Colors.darkGreen,
    borderRadius: 8,
    position: "relative",
    padding: 16,
    paddingVertical: 24,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  WaitingList: {
    fontSize: 56,
    color: "#C0A46F",
    fontFamily: "PlayfairDisplay-Black",
  },
  flexJustify: {
    flexDirection: "row",
    justifyContent: "center",
    gap: 8,
    marginBottom: 27,
    marginTop: 20,
    alignItems: "center",
    width: "100%",
  },
  HomeDisplayCards: {
    width: "100%",
    // minHeight: 480,
  },
  HomeDisplayCard: {
    width: "100%",
    position: "relative",
    overflow: "hidden",
    borderRadius: 8,
    maxHeight: 480,
    minHeight: 480,
    marginBottom: 8,
  },
  ScreenWrapper: {
    paddingHorizontal: 16,
  },
  seperation: {
    marginTop: 20,
    marginBottom: 20,
    alignItems: "center",
  },
  WaitingListSecondary: {
    color: "#F3EAE1",
    fontSize: 20,
  },
  CrossIcon: {
    position: "absolute",
    bottom: 25,
    left: 16,
    backgroundColor: "white",
    borderRadius: 50,
    padding: 16,
    width: 60,
    height: 60,
    zIndex: 1,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 0,
    },
    shadowOpacity: 0.4,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    shadowRadius: 10,
    elevation: 1,
  },
  reportButton: {
    borderColor: "rgba(0, 0, 0, 0.7)",
    borderWidth: 0.5,
    borderRadius: 50,
    marginTop: 26,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    paddingVertical: 16,
    width: "70%",
    marginBottom: 18,
    marginRight: 16,
    marginLeft: "auto",
  },
  Experiences: {
    paddingHorizontal: 16,
    marginTop: 32,
    width: "100%",
  },
});
